export const INSTAGRAM_URL = "https://www.instagram.com/candorlanae/"
export const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=100049107806323"
export const TOMMASO_AMADORI_URL = "https://tomgeek27.github.io/portfolio"
export const MAIL_URL = "mailto:info@candorlanae.com"